// src/pages/Login/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    
    if (username === 'admin' && password === 'admin123') {
      // 1. กำหนดเวลาหมดอายุ (ปัจจุบัน + 1 ชั่วโมง)
      const now = new Date();
      const expiryTime = now.getTime() + (60 * 60 * 1000); // 1 ชั่วโมง (หน่วย millisecond)

      // 2. สร้าง Object Session
      const sessionData = {
        user: username,
        token: 'mock-token-' + Math.random().toString(36).substr(2), // จำลอง Token
        expiry: expiryTime
      };

      // 3. บันทึกลง LocalStorage
      localStorage.setItem('v2x_session', JSON.stringify(sessionData));

      // 4. แจ้ง App ว่า Login สำเร็จ
      onLogin(); 
      navigate('/dashboard');
    } else {
      alert('Invalid credentials! (Try: admin / 1234)');
    }
  };

  // ... (ส่วน return UI ใช้โค้ดเดิมได้เลยครับ)
  return (
    <div style={styles.container}>
        {/* ... UI เดิม ... */}
        <div style={styles.card}>
            <h2 style={{ marginBottom: '20px' }}>V2X Login</h2>
            <form onSubmit={handleLogin}>
                <input 
                    style={styles.input} 
                    type="text" 
                    placeholder="Username" 
                    value={username} onChange={(e)=>setUsername(e.target.value)} 
                />
                <br/><br/>
                 <input 
                    style={styles.input} 
                    type="password" 
                    placeholder="Password" 
                    value={password} onChange={(e)=>setPassword(e.target.value)} 
                />
                <br/><br/>
                <button style={styles.button} type="submit">Login</button>
            </form>
        </div>
    </div>
  );
};

const styles = {
    container: { height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f0f2f5'},
    card: { padding: '40px', background: 'white', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', textAlign: 'center'},
    input: { padding: '10px', width: '200px', borderRadius: '5px', border: '1px solid #ccc'},
    button: { padding: '10px 20px', background: '#6a1b9a', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer'}
}

export default LoginPage;